import { filter, flatMap, isEmpty } from "lodash"
import { FormItemInstance, FormValidError } from "./form.shared"

export function validateAll(fields: FormItemInstance[]) {
  return new Promise<void>((resolve, reject) => {
    Promise.all(
      fields.map((field) =>
        field.validate().then(
          () => [] as FormValidError[],
          (reason) => [reason] as FormValidError[],
        ),
      ),
    )
      .then((errors) => flatMap<FormValidError[], FormValidError>(errors, (error) => error))
      .then((errors) => filter<FormValidError>(errors, (error) => !isEmpty(error.errors)))
      .then((errors) => {
        if (!isEmpty(errors)) {
          reject(errors)
        } else {
          resolve()
        }
      })
  })
}

export function validateSequence(fields: FormItemInstance[]): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    fields
      .reduce(
        (promise, field) =>
          promise.then((errors) => {
            if (isEmpty(errors)) {
              return field.validate().then(
                () => [],
                (error) => [error],
              )
            }
            return errors
          }),
        Promise.resolve<FormValidError[]>([]),
      )
      .then((errors) => {
        if (isEmpty(errors)) {
          resolve()
        } else {
          reject(errors)
        }
      })
  })
}
